import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CompanyService } from '../../services/company.service';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AppDataService } from '../../services/app-data.service';
import { TreinamentoComponent } from '../treinamento/treinamento.component';

declare var Swiper: any;

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
})
export class LandingPageComponent implements OnInit, OnDestroy {
  companyData: any;
  public menuClose = false;
  isHovered: boolean = false;
  isModalOpen: boolean = false;
  selectedSection: any;
  router: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private _companyService: CompanyService,
    private _router: Router,
    public _appData: AppDataService,
    public _routeParams : ActivatedRoute
  ) {this.isMobile = window.innerWidth <= 768;}
  isVideoModalOpen: boolean = false;
  currentVideoSection: any;
  selectedVideo: any;
  openVideoModal(section: any) {
    this.selectedSection = section;
    this.isModalOpen = true;

    const videoId = section.id; // Presuma que cada seção tem um ID único

    // Atualiza a URL para incluir a nova rota
    this._router.navigate([`landing/treinamento/${videoId}`], {
      queryParams: {
        title: encodeURIComponent(section.title),
        room: this.companyData.room
      },
      queryParamsHandling: 'merge'
    });
    document.body.classList.add('modal-open');

  }
  goToTreinamento(): void {
    console.log("Navegando para a página de treinamento...");
    const queryParams = this._routeParams.snapshot.queryParams;

    this._router.navigate(['/treinamento'], { queryParams }).then(success => {
      console.log("Navegação com sucesso:", success);
    }).catch(err => {
      console.error("Erro ao navegar:", err);
    });
  }



  // openVideoModal(section: any) {
  //   this.selectedSection = section;
  //   this.isModalOpen = true;

  //   const videoTitle = section.title;

  //   if (videoTitle) {
  //     // Atualiza a URL para incluir a nova rota
  //     this._router.navigate(['.', { outlets: { modal: ['video'] } }], {
  //       relativeTo: this.route,
  //       queryParams: {
  //         title: encodeURIComponent(videoTitle), // Adiciona o título da seção
  //         room: this.companyData.room // Adiciona o room se necessário
  //       },
  //       queryParamsHandling: 'merge' // Mantém outros parâmetros que já estão na URL
  //     });

  //     document.body.classList.add('modal-open');
  //   } else {
  //     console.error("Título da seção não encontrado.");
  //   }
  // }

  closeVideoModal() {
    this.isModalOpen = false;
    this.selectedSection = null;

    document.body.classList.remove('modal-open');

    // Remove o modal da URL
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        modal: null,
        title: null // Limpa o título da seção
      },
      queryParamsHandling: 'merge' // Mantém outros parâmetros que já estão na URL
    });
  }
videoTitle: string | null = null;

  ngOnInit(): void {
    this.toggleDarkMode();
    this._routeParams.queryParams.subscribe(params => {
      var companyId = params.id
      var landing = params.lid

      this._companyService.getLandingCompany(companyId).collection('websites').doc(landing).get().then(doc => {
        let main = document.getElementById("main");
        main.style.removeProperty("overflow");
        if (doc.exists) {
          this.companyData = doc.data();
          this._appData.gameUrl = "/gamephoto.html?room=" + this.companyData.room;
          if (isPlatformBrowser(this.platformId)) {
            this.loadSwiper();
          }
        } else {
          console.error("Documento não encontrado");
        }
      }).catch(error => {
        console.error("Erro ao obter dados da empresa:", error);
      });
    })
    // Adiciona o scroll event listener
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('scroll', this.onScroll, true);
    }
  }

  ngOnDestroy() {
    // Remove o scroll event listener
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('scroll', this.onScroll, true);
    }
  }

  onScroll = (): void => {
    const header = document.querySelector('.header');
    if (header) {
      header.classList.toggle('sticky', window.scrollY > 100);
    }
  }

  loadSwiper() {
    const script = this.renderer.createElement('script');
    script.src = 'https://unpkg.com/swiper/swiper-bundle.min.js';
    script.onload = () => this.initializeSwiper();
    this.renderer.appendChild(document.body, script);
  }

  initializeSwiper() {
    const swiper = new Swiper('.mySwiper', {
      slidesPerView: 1,
      spaceBetween: 50,
      loop: true,
      grabCursor: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }

  @ViewChild('menuIcon') menuIcon!: ElementRef; @ViewChild('navbar') navbar!: ElementRef; public isMenuOpen: boolean = false;

  // @ViewChild('navbar') navbar!: ElementRef;

  public navigateToGame() {
    let game=document.getElementById('gameFrame')
    game.style.visibility='visible';
    let main2=document.getElementById('main2')
    main2.remove();
    let main = document.getElementById("main");
    main.style.overflow='hidden';

    //    this._router.navigate(['gameevent',1592880902713],{ queryParams: {room: this.companyData.room}})
  }

  public scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }
  toggleVideoSection(section: any): void {
    section.showVideos = !section.showVideos; // Alterna a visibilidade dos vídeos
  }
  public isMobile: boolean = false;

  toggleDarkMode(): void {
    const darkModeIcon = document.querySelector('#darkMode-icon');
    const htmlElement = document.documentElement; // Seleciona o elemento <html>

    if (darkModeIcon && htmlElement) {
      darkModeIcon.addEventListener('click', () => {
        darkModeIcon.classList.toggle('bx-sun');
        htmlElement.classList.toggle('dark-mode');
      });
    }
  }



      toggleMenu(): void {
        this.isMenuOpen = !this.isMenuOpen;

        if (this.isMobile) {
          const navbar = document.querySelector('.navbar') as HTMLElement;

          if (navbar) {
            if (this.isMenuOpen) {
              navbar.style.display = 'block';
              setTimeout(() => {
                navbar.classList.add('active');
              }, 50);
            } else {
              navbar.classList.remove('active');
              setTimeout(() => { navbar.style.display = 'none'; }, 300);
            }
          }

        }
      }

     @HostListener('window:resize', ['$event']) onResize(event: any) {
      this.isMobile = event.target.innerWidth <= 768;
      const navbar = document.querySelector('.navbar') as HTMLElement;
        if (!this.isMobile && navbar) {
          navbar.style.display = 'block';
        }
      }

  applyDynamicStyles(): void {
    if (this.companyData && this.companyData.sections) {
      const homeOverlayColor = this.companyData.sections[0]?.homeOverlay; // Get the homeOverlay value
      if (homeOverlayColor) {
        this.renderer.setStyle(document.documentElement, '--home-overlay-color', homeOverlayColor);
      }
      const border = this.companyData.border;
      if (border){
        this.renderer.setStyle(document.documentElement, '--border', border);
      }
    }

  }

  onMouseOver(): void {
    if (this.companyData && this.companyData.sections) {
      const border = this.companyData.border;
      if (border){
        this.renderer.setStyle(document.documentElement, '--border', border);
      }
    }
  }

  onMouseOut(): void {
    // Redefina a cor para a cor normal aqui
    this.companyData.border = 'cor-normal';
  }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/landing-page/landing-page.component.ts